import { authConfigSnapshot } from '../repositories/auth.repository';

type DebugSource = 'Auth Guard' | 'Auth State';
const colorMap = new Map<DebugSource, string>([
  ['Auth Guard', '#4ea646'],
  ['Auth State', '#217cbb'],
]);

export const debugMessage = (source: DebugSource, message: string) => {
  if (authConfigSnapshot().settings.enableDebugLog) {
    console.debug(
      `%c${source}: %c${message}`,
      `color: ${colorMap.get(source) ?? '#fff'}`,
      'color: #fff'
    );
  }
};
